module.exports = __webpack_public_path__ + "img/myself03.b68c1dbb.png";